import { createContext, useContext, useEffect, useLayoutEffect, useRef } from 'react';

// Lets screens rendered inside a persistent AuthShellLayout configure the
// shell (currently the back button) without remounting it — the shell staying
// mounted across auth routes is what keeps the background and card from
// flashing on navigation.
export const AuthShellConfigContext = createContext(null);

export const useAuthShellConfig = ({ backTo = null, onBack = null } = {}) => {
  const setConfig = useContext(AuthShellConfigContext);
  const onBackRef = useRef(onBack);
  // Commit-phase write — mutating the ref during render could leak a handler
  // from a render React discards. Runs before the config effect below.
  useLayoutEffect(() => {
    onBackRef.current = onBack;
  }, [onBack]);
  const hasOnBack = !!onBack;

  useEffect(() => {
    if (!setConfig) return undefined;
    setConfig({
      backTo,
      onBack: hasOnBack ? () => onBackRef.current?.() : null
    });
    return () => setConfig({});
  }, [setConfig, backTo, hasOnBack]);
};
